<ng-content></ng-content>

<ng-template #dragItemPlacehoder>
  <div
    class="phx-drag-item-placeholder"
    [ngStyle]="placeholderStyles"
    [ngClass]="phxPlaceholderClass"
  ></div>
</ng-template>
